module.exports = __webpack_public_path__ + "img/assembling_new_1200x800.af7bd0e9.svg";